/* eslint-disable unicorn/prefer-module */
import React, { useMemo } from "react";
import { useAuthContext } from "../../context/auth";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { fullScreenPlugin } from "@react-pdf-viewer/full-screen";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import "./stylesMediakitEdificios.scss";

function MediakitEdificios() {
  const { pais } = useAuthContext();
  const newplugin = defaultLayoutPlugin();
  const getFilePluginInstance = getFilePlugin();
  const fullScreenPluginInstance = fullScreenPlugin();

  const mediakit = useMemo(
    () =>
      ({
        Chile: require("../../pdf/edificios-wecast.pdf"),
        Perú: require("../../pdf/edificios-wecast.pdf"),
        Uruguay: require("../../pdf/edificios-wecast.pdf"),
      })[pais] || require("../../pdf/edificios-wecast.pdf"),
    [pais]
  );

  // Renderizado condicional: Chile y Perú usan Canva, otros usan PDF
  if (pais === "Perú") {
    return (
      <div className="pdf-container">
        <div className="iframe-wrapper">
          <iframe
            loading="lazy"
            src="https://www.canva.com/design/DAGcFIgAaTg/CFeyrXe7FSm0qnnPlcNBJw/view?embed"
            allowFullScreen="allowfullscreen"
            allow="fullscreen"
            title="Perú Media Kit"
            style={{ minHeight: "100vh", width: "100vw", height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
    );
  }

  if (pais === "Chile") {
    return (
      <div className="pdf-container">
        <div className="iframe-wrapper">
          <iframe
            loading="lazy"
            src="https://www.canva.com/design/DAGylJmHMLE/kkej7Gpotvn8HQ96ComdEQ/view?embed"
            allowFullScreen="allowfullscreen"
            allow="fullscreen"
            title="Chile Media Kit"
            style={{ minHeight: "100vh", width: "100vw", height: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-container">
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <Viewer fileUrl={mediakit} plugins={[newplugin, getFilePluginInstance, fullScreenPluginInstance]} />
      </Worker>
    </div>
  );
}

export default MediakitEdificios;
